import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

var _createReducer, _createReducer2;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "@babel/runtime/regenerator";
import { createAction, createCachedSelector, createReducer, createSelector, startLoading, stopLoading, upToDateStatus, outOfDateStatus, updateSessionDetail } from '@techstyle/redux-core';
import logger from './logger';
var debug = logger.extend('marketingModule');
var initialState = {
  funnels: {},
  marketing: {
    requestInfo: {},
    pageInfo: {},
    referrerOptions: {
      options: [],
      networkStatus: outOfDateStatus()
    },
    disposition: {
      networkStatus: outOfDateStatus()
    }
  }
};
export var setRequestInfo = createAction('marketing/setRequestInfo');
export var setPageInfo = createAction('marketing/setPageInfo');
export var loadFunnelRequest = createAction('marketing/loadFunnelRequest');
export var loadFunnelSuccess = createAction('marketing/loadFunnelSuccess');
export var loadFunnelFailure = createAction('marketing/loadFunnelFailure');
export var addContactRequest = createAction('marketing/addContactRequest');
export var addContactSuccess = createAction('marketing/addContactSuccess');
export var addContactFailure = createAction('marketing/addContactFailure');
export var verifyContactRequest = createAction('marketing/verifyContactRequest');
export var verifyContactSuccess = createAction('marketing/verifyContactSuccess');
export var verifyContactFailure = createAction('marketing/averifyContactFailure');
export var loggedInPageView = createAction('marketing/loggedInPageView');
export var loadDirectMarketingDispositionRequest = createAction('marketing/loadDirectMarketingDispositionRequest');
export var loadDirectMarketingDispositionSuccess = createAction('marketing/loadDirectMarketingDispositionSuccess');
export var loadDirectMarketingDispositionFailure = createAction('marketing/loadDirectMarketingDispositionFailure');
export var getDirectMarketingGatewayByCodeRequest = createAction('marketing/getDirectMarketingGatewayByCodeRequest');
export var getDirectMarketingGatewayByCodeSuccess = createAction('marketing/getDirectMarketingGatewayByCodeSuccess');
export var getDirectMarketingGatewayByCodeFailure = createAction('marketing/getDirectMarketingGatewayByCodeFailure');
export var getDirectMarketingSiteByIdRequest = createAction('marketing/getDirectMarketingSiteByIdRequest');
export var getDirectMarketingSiteByIdSuccess = createAction('marketing/getDirectMarketingSiteByIdSuccess');
export var getDirectMarketingSiteByIdFailure = createAction('marketing/getDirectMarketingSiteByIdFailure');
export var loadReferrerOptionsRequest = createAction('marketing/loadReferrerOptionsRequest');
export var loadReferrerOptionsSuccess = createAction('marketing/loadReferrerOptionsSuccess');
export var loadReferrerOptionsFailure = createAction('marketing/loadReferrerOptionsFailure');
export var FunnelErrorType = {
  OTHER: 'OTHER'
};
export function initFunnel() {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState, context) {
      var isServer, request, _request$query, promo, theme, funnelOverride;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // access context to check two things:
              // we are on the server
              // there is request data on context
              isServer = context.isServer, request = context.req; // actually ensure we're on the server and there are request params

              if (!(isServer && request)) {
                _context.next = 10;
                break;
              }

              // if there, destructure params off request
              _request$query = request.query, promo = _request$query.promo, theme = _request$query.theme; // if either promo or theme are missing in url, do nothing

              if (!(!promo || !theme)) {
                _context.next = 5;
                break;
              }

              return _context.abrupt("return");

            case 5:
              // set up funnel override object
              funnelOverride = {
                name: 'origin',
                value: JSON.stringify({
                  promo: promo,
                  theme: theme
                })
              }; // dispatch events to update session detail state & funnel state
              // set session detail state

              _context.next = 8;
              return dispatch(updateSessionDetail(funnelOverride));

            case 8:
              _context.next = 10;
              return dispatch(loadFunnel(promo));

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }();
}
export function loadFunnel(funnelKey) {
  if (!funnelKey) {
    throw new Error("loadFunnel must be called with a funnel key");
  }

  return function (dispatch, getState) {
    var state = getState();
    var funnels = state.funnels;
    var funnel = funnels[funnelKey];
    var shouldFetch = false;

    if (funnel) {
      if (funnel.networkStatus.isLoading) {// Already loading, do nothing.
      } else if (funnel.error) {
        // Don't attempt to fetch if there was an error last time!
        debug('funnelKey has error; skipping refetch.', funnelKey);
      } else if (!funnel.networkStatus.isUpToDate) {
        debug('funnelKey has been invalidated; refetching.', funnelKey);
        shouldFetch = true;
      }
    } else {
      shouldFetch = true;
    }

    if (shouldFetch) {
      return dispatch({
        bentoApi: {
          endpoint: "funnel/".concat(funnelKey),
          requestKey: "loadFunnel-".concat(funnelKey),
          actions: [function (payload, meta) {
            return loadFunnelRequest(payload, _objectSpread(_objectSpread({}, meta), {}, {
              funnelKey: funnelKey
            }));
          }, function (payload, meta) {
            return loadFunnelSuccess(payload, _objectSpread(_objectSpread({}, meta), {}, {
              funnelKey: funnelKey
            }));
          }, function (payload, meta) {
            return loadFunnelFailure(payload, _objectSpread(_objectSpread({}, meta), {}, {
              funnelKey: funnelKey
            }));
          }]
        }
      });
    }
  };
}
export function addContact(payload) {
  if (!payload) {
    throw new Error('addContact must be given a payload object.');
  }

  return {
    bentoApi: {
      method: 'POST',
      endpoint: 'contacts',
      requestKey: 'addContact',
      json: payload,
      actions: [addContactRequest, addContactSuccess, addContactFailure]
    }
  };
}
export function verifyContact(email) {
  if (!email) {
    throw new Error('verifyContact must be given an email.');
  }

  return {
    bentoApi: {
      endpoint: "contacts/verify?email=".concat(email),
      method: 'GET',
      actions: [verifyContactRequest, verifyContactSuccess, verifyContactFailure]
    }
  };
}
export var funnelReducer = createReducer(initialState.funnels, (_createReducer = {}, _defineProperty(_createReducer, loadFunnelRequest, function (state, action) {
  var funnelKey = action.meta.funnelKey;
  var funnel = state[funnelKey];

  if (!funnel) {
    funnel = state[funnelKey] = {
      networkStatus: outOfDateStatus()
    };
  }

  startLoading(funnel);
}), _defineProperty(_createReducer, loadFunnelFailure, function (state, action) {
  var funnelKey = action.meta.funnelKey;
  var funnel = state[funnelKey];
  funnel.error = FunnelErrorType.OTHER;
  stopLoading(funnel);
}), _defineProperty(_createReducer, loadFunnelSuccess, function (state, action) {
  var funnelKey = action.meta.funnelKey;
  state[funnelKey] = {
    data: action.payload,
    networkStatus: upToDateStatus()
  };
}), _createReducer));
export var marketingReducer = createReducer(initialState.marketing, (_createReducer2 = {}, _defineProperty(_createReducer2, setPageInfo, function (state, action) {
  state.pageInfo = _objectSpread({}, action.payload);
}), _defineProperty(_createReducer2, setRequestInfo, function (state, action) {
  state.requestInfo = _objectSpread({}, action.payload);
}), _defineProperty(_createReducer2, loadReferrerOptionsRequest, function (state) {
  startLoading(state.referrerOptions);
}), _defineProperty(_createReducer2, loadReferrerOptionsFailure, function (state) {
  stopLoading(state.referrerOptions);
}), _defineProperty(_createReducer2, loadReferrerOptionsSuccess, function (state, action) {
  state.referrerOptions.options = action.payload;
  state.referrerOptions.networkStatus = upToDateStatus();
}), _defineProperty(_createReducer2, loadDirectMarketingDispositionRequest, function (state) {
  startLoading(state.disposition);
}), _defineProperty(_createReducer2, loadDirectMarketingDispositionFailure, function (state) {
  stopLoading(state.disposition);
}), _defineProperty(_createReducer2, loadDirectMarketingDispositionSuccess, function (state, action) {
  state.disposition = _objectSpread(_objectSpread({}, action.payload), {}, {
    networkStatus: upToDateStatus()
  });
}), _createReducer2));
export var getRaygunUser = createSelector([function (state) {
  return state.session;
}, function (state) {
  return state.customer;
}], function (session, customer) {
  if (customer.customerKey) {
    var firstName = customer.firstName,
        lastName = customer.lastName;
    var fullName = firstName && lastName ? "".concat(firstName, " ").concat(lastName) : firstName;
    return {
      identifier: customer.customerKey,
      isAnonymous: false,
      email: customer.email || undefined,
      firstName: firstName || undefined,
      fullName: fullName || undefined
    };
  } else if (session.sessionVisitor) {
    return {
      identifier: session.sessionVisitor,
      isAnonymous: true
    };
  } else {
    // It may be possible for there to be no session, if we land on a page
    // that doesn't require any API calls and has set `sessionRequired` to
    // false. The docs say to "pass in empty strings" to reset the current
    // user, although it's not clear if this can also apply to the
    // `identifier` field. But we don't have an identifier, so this seems apt.
    // See: https://github.com/MindscapeHQ/raygun4js#resetting-the-user
    return {
      identifier: '',
      isAnonymous: true
    };
  }
});
export var getMarketingInfo = createSelector([function (state) {
  return state.marketing;
}], function (marketingInfo) {
  return marketingInfo;
});
export function loadDirectMarketingDisposition(code) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(dispatch, getState, context) {
      var _options$gender, gender, networkStatus, hasChanges;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _options$gender = options.gender, gender = _options$gender === void 0 ? '' : _options$gender;
              networkStatus = getState().marketing.disposition.networkStatus; // hasChanges is intended to check that this call is not
              // intended to update the disposition because marketing/disposition
              // acts as both a GET and a POST endpoint

              hasChanges = code || (gender === null || gender === void 0 ? void 0 : gender.length);

              if (!(!networkStatus.isUpToDate || hasChanges)) {
                _context2.next = 5;
                break;
              }

              return _context2.abrupt("return", dispatch({
                bentoApi: {
                  endpoint: "marketing/disposition",
                  method: 'GET',
                  requestKey: JSON.stringify(['directMarketingDisposition', code, gender]),
                  searchParams: {
                    code: code,
                    gender: gender
                  },
                  actions: [loadDirectMarketingDispositionRequest, loadDirectMarketingDispositionSuccess, loadDirectMarketingDispositionFailure]
                }
              }));

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x4, _x5, _x6) {
      return _ref2.apply(this, arguments);
    };
  }();
}
export var getDirectMarketingDisposition = createSelector([function (state) {
  return state.marketing.disposition;
}], function (disposition) {
  return disposition;
});
export function getDirectMarketingGatewayByCode(code) {
  return {
    bentoApi: {
      endpoint: "marketing/dmg/".concat(code),
      method: 'GET',
      requestKey: JSON.stringify(['directMarketingGatewayByCode', code]),
      actions: [getDirectMarketingGatewayByCodeRequest, getDirectMarketingGatewayByCodeSuccess, getDirectMarketingGatewayByCodeFailure]
    }
  };
}
export function getDirectMarketingSiteById(dmSiteId) {
  return {
    bentoApi: {
      endpoint: "marketing/dms/".concat(dmSiteId),
      method: 'GET',
      requestKey: JSON.stringify(['directMarketingSiteById', dmSiteId]),
      actions: [getDirectMarketingSiteByIdRequest, getDirectMarketingSiteByIdSuccess, getDirectMarketingSiteByIdFailure]
    }
  };
}
export function loadReferrerOptions() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    bentoApi: {
      endpoint: 'marketing/referrers',
      method: 'GET',
      requestKey: 'referrerOption',
      searchParams: params,
      actions: [loadReferrerOptionsRequest, loadReferrerOptionsSuccess, loadReferrerOptionsFailure]
    }
  };
}
export var getFunnel = createCachedSelector([function (state, funnelKey) {
  return state.funnels[funnelKey];
}, function (state, funnelKey) {
  return funnelKey;
}], function (funnel, funnelKey) {
  if (funnel) {
    return _objectSpread({
      funnelKey: funnelKey
    }, funnel);
  }

  return {
    funnelKey: funnelKey,
    fetchedDate: null,
    networkStatus: outOfDateStatus()
  };
})(function (state, funnelKey) {
  return funnelKey;
});
export default {
  id: 'marketing',
  reducerMap: {
    funnels: funnelReducer,
    marketing: marketingReducer
  },
  initialActions: [initFunnel()]
};